<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title has-text-weight-medium">
                {{ document.strDocument }}
            </p>
        </header>
        <section class="modal-card-body">
            <pdf
                :src="document.SignedUrl"
                :page="1"
                :resize="true"
            >
                <template slot="loading">
                    Loading content...
                </template>
            </pdf>
        </section>
    </div>
</template>

<script>
import pdf from 'pdfvuer';

export default {
    components: {
        pdf,
    },

    props: {
        document: {
            type: Object,
            required: true,
        },
    },
};
</script>
